module.exports = "/packs/images/icons/icon-x-dc1666eec9dbd764826548d614926714.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/icons/icon-x.svg
// module id = 1794
// module chunks = 0